import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {omit} from 'lodash';
import {commitMutation, graphql} from 'react-relay';
import {createRangeBulkAddUpdater} from '../relay-helpers/RelayCacheHelpers';

const mutation = graphql`
	mutation ImportHubspotCompaniesMutation($input: ImportHubspotCompaniesInput!) {
		importHubspotCompanies(input: $input) {
			clients {
				cursor
				node {
					id
					name
					notes
					logoId
					logoDefaultId
					projectCount
					economicCustomerId
					quickbooksCustomerId
					xeroContactId
					salesforceAccountId
					hubspotCompanyId
					pipedriveOrganizationId
					sageIntacctCustomerId
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Bulk Clients Created');
	const cleanedInput = omit(input, ['companyId']);

	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		updater: createRangeBulkAddUpdater(input.companyId, 'importHubspotCompanies', 'clients', 'Company_clients'),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
